<template>
    <form-submit-row no-flex @submit="submit" :redirect-on-cancel="redirectOnCancel" :floating="floating">
        <div class="flex button-container flex-align-right" :class="{'buttons-grid-50': gridView, 'flex-wrap': !gridView}">
            <slot name="save" v-if="showSaveButtons">
                <form-input-save type="submit" name="action_save" class="submit-form flex--order-10"/>
            </slot>

            <slot name="apply" v-if="showSaveButtons">
                <form-input-submit v-if="viewSize.lgUp" name="action_apply" class="button button-apply flex--order-9">
                    <i class="material-icons" aria-hidden="true" v-text="SubmitIcons.save" role="img"></i> <span>Zwischenspeichern</span>
                </form-input-submit>
            </slot>

            <form-input-submit name="action_previous" formnovalidate="formnovalidate" class="button button-back flex--order-7"
                @click.stop.prevent="previousStep" v-if="!isFirst">
                <i class="material-icons" aria-hidden="true" v-text="SubmitIcons.navigate_before" role="img"></i>{{viewSize.smDown ? 'Zurück' : 'Vorheriger Schritt'}}
            </form-input-submit>

            <form-input-submit name="action_next" formnovalidate="formnovalidate" class="button button-next flex--order-8"
                @click.stop.prevent="nextStep" :disabled="disableSave" v-if="!isLast">
                <i class="material-icons" aria-hidden="true" v-text="SubmitIcons.navigate_next" role="img"></i>{{viewSize.smDown ? 'Weiter' : 'Nächster Schritt'}}
            </form-input-submit>

            <div class="button-separator flex--order-2"/>

            <form-input-submit name="action_cancel" formnovalidate="formnovalidate" class="button button-cancel flex--order-1 spacer-right-15">
                <i class="material-icons" aria-hidden="true" v-text="SubmitIcons.close" role="img"></i><span>Abbrechen</span>
            </form-input-submit>
        </div>
    </form-submit-row>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator';
    import {SubmitIcons} from '../../library/design';
    import {getVueParent} from '../../library/dom';
    import FormInputSave from './FormInputSave.vue';
    import FormInputSubmit from './FormInputSubmit.vue';
    import FormSteps from './FormSteps.vue';
    import FormSubmitRow from './FormSubmitRow.vue';

    @Component({
        name: 'FormStepsSubmitRow',
        components: {
            FormInputSave,
            FormInputSubmit,
            FormSubmitRow,
        },
        emits: ['submit'],
    })
    export default class FormStepsSubmitRow extends Vue
    {
        @Prop({
            type: Boolean,
            required: true,
        }) isCreate: boolean;

        @Prop({
            type: Boolean,
            default: true,
            required: false,
        }) floating: boolean;

        @Prop({
            type: String,
            default: 'smDown',
            required: false,
        }) gridBreakpoint: string;

        @Prop({
            type: [String, Object],
            default()
            {
                return {};
            },
        }) redirectOnCancel: string | object;

        @Prop({
            type: Boolean,
            default: false,
            required: false,
        }) disableSave: boolean;

        formSteps: Nullable<FormSteps> = null;

        SubmitIcons = SubmitIcons;

        get isFirst()
        {
            return this.formSteps?.first || false;
        }

        get isLast()
        {
            return this.formSteps?.last || false;
        }

        get showSaveButtons()
        {
            return this.isLast || !this.isCreate;
        }

        get gridView()
        {
            return this.viewSize[this.gridBreakpoint];
        }

        created()
        {
            let formSteps = getVueParent(this, 'FormSteps') as Nullable<FormSteps>;

            if (!formSteps)
            {
                throw new Error('[FormStepsSubmitRow]: No FormSteps parent component found');
            }

            this.formSteps = formSteps;
        }

        submit(target: HTMLElement | HTMLInputElement | HTMLButtonElement)
        {
            this.$emit('submit', target);
        }

        previousStep()
        {
            this.formSteps?.previous();
        }

        nextStep()
        {
            this.formSteps?.next();
        }
    }
</script>